import React, { useState, useRef, KeyboardEvent } from 'react'
import { useController, Control, FieldValues, Path } from 'react-hook-form'
import './ICSSimpleTagBox.css'

interface CustomTagBoxProps<
  TFieldValues extends FieldValues,
  K extends Path<TFieldValues>
> {
  name: K
  control: Control<TFieldValues>
  placeholder?: string
}

const CustomTagBox = <
  TFieldValues extends FieldValues,
  K extends Path<TFieldValues>
>({
  name,
  control,
  placeholder = 'Type and press Enter'
}: CustomTagBoxProps<TFieldValues, K>) => {
  const {
    field: { value, onChange, ref },
    fieldState: { error }
  } = useController({ name, control })

  const [inputValue, setInputValue] = useState('')
  const inputRef = useRef<HTMLInputElement>(null)

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && inputValue.trim()) {
      e.preventDefault()
      const currentTags = Array.isArray(value) ? (value as string[]) : []
      if (!currentTags.includes(inputValue.trim())) {
        onChange([...currentTags, inputValue.trim()])
      }
      setInputValue('')
    }
  }

  const removeTag = (tagToRemove: string) => {
    const currentTags = Array.isArray(value) ? value : []
    onChange(currentTags.filter((tag) => tag !== tagToRemove))
  }

  return (
    <div className="custom-tagbox-wrapper">
      <div className="tag-list">
        {Array.isArray(value) &&
          value.map((tag) => (
            <div key={tag} className="tag">
              {tag}
              <button
                type="button"
                onClick={() => removeTag(tag)}
                className="remove-btn"
              >
                ×
              </button>
            </div>
          ))}
        <input
          ref={inputRef}
          className="tag-input"
          value={inputValue}
          placeholder={placeholder}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyDown={handleKeyDown}
        />
      </div>
      {error && <div className="error-text">{error.message}</div>}
    </div>
  )
}

export default CustomTagBox
